import React,{useState,useEffect} from 'react';
import LoaderImg from '../../assets/images/loader.gif'
import { useNavigate, useParams} from 'react-router-dom';
import swal from 'sweetalert';

const CCAvenuePaymentStatus = (props) => {
    const navigate = useNavigate();
    const useParam = useParams();
    const [loading,setLoading] = useState(true)

      useEffect(()=>{
        if(useParam.status === 'success'){
          swal('Congratulations Your fee submited successfully.','','success')
          navigate('/dashboard');
        }
        else{
            swal('Your payment is failed please try again.','','error')
            navigate('/dashboard');
        }
    })

  return (
     <>
      {loading ? <div className="screenLoader text-center flex-wrap">
      <img src={LoaderImg} alt="Loading..." style={{width:'140px'}}/>
      <span className='d-block w-100 fw-bold text-center'>Please wait while your payment processing</span>
      </div>:
      <>
      <div className='payment-successfull'></div>
    </>
      }
    </>
    
  )
}

export default CCAvenuePaymentStatus
